'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

// TODO : authz for routes -> interceptor

ngModule.factory("$authz", function ($session) {
  var roleIntra = "INTRA_TAELYS";
  /**
   *
   * permet à un consultant d'afficher le site sans tenir compte du droit INTRA ne concerne que le front.
   */
  var roleIntraAvecVueClient = "INTRA_TAELYS_AVEC_VUE_CLIENT";
  var user = null,
    roles = {};
  var setUser = function setUser(_user, _habilitations) {
    user = _user;
    setRoles(_habilitations);
  };
  function setRoles(habilitations) {
    roles = {};
    _.each(habilitations, function (role) {
      roles[role] = true;
    });
  }
  var $authz = {
    $setUser: setUser,
    getId: function getId() {
      return user.id;
    },
    isClient: function isClient() {
      return !$authz.hasRole(roleIntra);
    },
    isIntra: function isIntra() {
      return !$authz.hasRole(roleIntraAvecVueClient) && $authz.hasRole(roleIntra);
    },
    hasRole: function hasRole(role) {
      return roles[role] === true;
    },
    hasRoles: function hasRoles(role1, role2, roleX) {
      var roles = arguments;
      if (roles.length === 1 && _.isArray(roles[0])) {
        roles = roles[0];
      }
      for (var i = 0; i < roles.length; i++) {
        if (!$authz.hasRole(roles[i])) {
          return false;
        }
      }
      return true;
    },
    hasAnyRole: function hasAnyRole(role1, role2, roleX) {
      var roles = arguments;
      if (roles.length === 1 && _.isArray(roles[0])) {
        roles = roles[0];
      }
      for (var i = 0; i < roles.length; i++) {
        if ($authz.hasRole(roles[i])) {
          return true;
        }
      }
      return false;
    }
  };
  return $authz;
});
ngModule.directive("authzIfClient", function ($authz, $animate) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($authz.isClient()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("authzIfIntra", function ($authz, $animate) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($authz.isIntra()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});

/**
 * authz-if-role="habililitation1||habililitation2".
 * Vous pouvez préfixer l'habilitation par ! pour tester le fait que l'utilisateur n'a pas ce rôle.
 * Utilisez || pour permettre plusieurs rôles
 */
ngModule.directive("authzIfRole", function ($authz, $animate) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      var roleNames = $attrs.authzIfRole;
      var found = false;
      var roles = roleNames.split('||');
      for (var i = 0; i < roles.length && !found; i++) {
        var inclusif = true;
        var roleName = roles[i].trim();
        if (roleName) {
          if (roleName.substr(0, 1) === '!') {
            inclusif = false;
            roleName = roleName.substr(1);
          }
          if (roleName && ($authz.hasRole(roleName) && inclusif || !$authz.hasRole(roleName) && !inclusif)) {
            found = true;
            $transclude($scope, function (clone) {
              $animate.enter(clone, $element.parent(), $element);
            });
          }
        }
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/security/$authz.js
// module id = 2721
// module chunks = 13